//Global
import Vue from 'vue'
import VueMeta from 'vue-meta';
import App from './App.vue'
import VueGtag from "vue-gtag";
import AOS from 'aos'
import 'aos/dist/aos.css'

//Tools
import { store } from './store';

//Styles
import './assets/sass/_app.scss'

//Off developer mode tip
Vue.config.productionTip = false;

// Google analytics
Vue.use(VueGtag, {
  config: { id: "UA-171804959-1" }
});

// Meta data support
Vue.use(VueMeta);

// [Do not delete] generates project
new Vue({
  store,
  render(createElement) {
    return createElement(App)
  },
  created(){
    AOS.init()
  }
}).$mount('#app')
